const defaultConfig = {
  API_SERVER: process.env.REACT_APP_API_SERVER,
  ENV: process.env.REACT_APP_ENV,
  NODE_ENV: process.env.REACT_APP_NODE_ENV
};

const appConfig = (configItemName) =>
  typeof window !== 'undefined' && window?._env_?.[configItemName] ? window._env_[configItemName] : defaultConfig[configItemName];

export default appConfig;
